var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarTracker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6032 2.22078L11.6034 2.22064C12.0213 1.76526 12.5137 1.40803 13.0506 1.16574C13.5872 0.923551 14.1597 0.8 14.7359 0.8C15.3121 0.8 15.8846 0.923551 16.4212 1.16574C16.9581 1.40803 17.4505 1.76526 17.8684 2.22064L17.8686 2.22092C18.2869 2.67622 18.6218 3.22043 18.8515 3.82403C19.0811 4.42767 19.2 5.07675 19.2 5.73364C19.2 6.39052 19.0811 7.0396 18.8515 7.64325C18.6218 8.24685 18.2869 8.79106 17.8686 9.24636L17.8685 9.2465L9.99974 17.8171L2.13097 9.2465C1.28547 8.32558 0.8 7.06298 0.8 5.73364C0.8 4.40429 1.28547 3.1417 2.13097 2.22078C2.97438 1.30215 4.10291 0.800557 5.26361 0.800557C6.4243 0.800557 7.55284 1.30215 8.39624 2.22078L9.41045 3.32544C9.56196 3.49047 9.77572 3.5844 9.99974 3.5844C10.2238 3.5844 10.4375 3.49047 10.589 3.32544L11.6032 2.22078Z",
    stroke: "#939295",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarTracker);
export default __webpack_public_path__ + "static/media/navbar-tracker.ea82afe681279ea4bb73270b5b4b538f.svg";
export { ForwardRef as ReactComponent };